<template>

    <div class="col">
        <p class="step-caption ft-bld">Enter content information & tags</p>
        <InputWrapper placeholder="Content name" v-model="Global.newContentOverlay.name" :max-chars="18"></InputWrapper>
        <AutoTagsWrapper placeholder="Tags" v-model="Global.newContentOverlay.tags"></AutoTagsWrapper>
        <TextareaWrapper placeholder="Content description" v-model="Global.newContentOverlay.description"></TextareaWrapper>
        <div class="nxt-out">
            <div class="btn main txt-blk" @click.prevent="switchStep('nxt')">
                <span class="hvr"></span>
                <span class="txt">Continue</span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import InputWrapper from '../../components/InputWrapper'
    import AutoTagsWrapper from '../../components/AutoTagsWrapper'
    import TextareaWrapper from '../../components/TextareaWrapper'

    export default {

        name: 'NewContentOne',

        components: {
            InputWrapper,
            AutoTagsWrapper,
            TextareaWrapper
        },

        data() {
            return {
                Global
            }
        },

        methods: {

            switchStep(dir) {
                this.$emit(dir)
            }

        }
    }

</script>